// @flow

export const FOOTER_DISCLAIMER_SECTIONS = {
  top: 'disclaimer-top-',
  numbered: 'disclaimer-numbered-',
  bottom: 'disclaimer-bottom-',
};
